'use strict';
import React from 'react';
import PropTypes from 'prop-types';
import Row from './Row.js';

class Grid extends React.Component {
    render() {
        const columnCount = this.props.columnCount;
        const gridItems = this.props.gridItems;

        const rows = [];
        for (let i = 0; i <= Math.floor(gridItems.length / columnCount); i++) {
            rows[i] = gridItems.slice(i * columnCount, i * columnCount + columnCount);
        }
       
        return (<div>
                {
                    rows.map((row, i) =>
                        <Row key={i}>
                            {row.map((rowItem, j) => rowItem)}
                        </Row>
                    )
                }
        </div>);
    }
}

Grid.propTypes = {
    columnCount: PropTypes.number.isRequired,
    gridItems: PropTypes.array.isRequired
};

Grid.defaultProps = {
    columnCount: 4
};

export default Grid;

